import { render } from "./AddUserPage.vue?vue&type=template&id=4591f52d&ts=true"
import script from "./AddUserPage.vue?vue&type=script&lang=ts"
export * from "./AddUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__